import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DropdownButton } from "react-bootstrap";
import { ButtonGroup } from "react-bootstrap";
import { Dropdown } from 'react-bootstrap';
import { circuitUsageActions } from "../../../../store/external/circuit-usage-reducer/circuit-usage.reducer";
import { createRequestActions } from "../../../../store/external/request-reducer/create-request.reducer";
import { ConfirmationModal } from "../../../common/modal/modal.component";
import {
    RAISE_REQUEST_LINKS as RaiseRequestLink
    , CIRCUIT_CATEGORIES as CircuitCategories
} from "../../../../constants/external-constants";
import { DASHBOARD_MENU as DashboardMenu, CIRCUIT_STATUS_PERSONAL as CircuitStatus } from "../../../../utils/constant.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { MATRIX_INDICATOR, ACCESS_MODULE } from "../../../../utils/rbac-constants.utils";
import Icon from "../../../icon";
import Translation from "../../../common/translation/translation.component";
import "./subscription-header.component.css";
import { CIRCUIT_STATUS } from "../../../../constants/external-constants";
import { convertToDate } from '../../../../utils/helpers.utils';
import FormatDate from "../../../common/date/format-date.component";
import { REQUEST_TYPE, REQUEST_TYPES_ID } from "../../../../constants/external-constants";
class SubscriptionOverviewInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showComponent: true
        }
        this.ConfirmationModal = React.createRef();
    }

    componentWillMount() {
        const { fetchCreateRequestItems } = this.props;

        fetchCreateRequestItems();
    }

    updateNavSelection = () => {
        var mainNavs = document.querySelectorAll(".main-menu");
        var subNav = document.querySelectorAll(".sub-list");
        subNav[0].classList.remove("subSelected");
        mainNavs[0].classList.remove("isActive");
        mainNavs[1].classList.add("isActive");

    }

    openRequestModal = (id, type) => {
        const { activeMenu, history, setRequestType, setTakeActionCircuitCode } = this.props;
        setRequestType(id, type);
        setTakeActionCircuitCode();

        if (parseInt(activeMenu) === parseInt(DashboardMenu.Personal)) {
            history.push("Dashboard/" + RaiseRequestLink.orderRequest.link + id);
        } else {
            history.push("Report/"+RaiseRequestLink.orderRequest.link + id);
        }

    };

    resetUrl = () => {
        this.props.history.goBack();
    }

    handleGeneratePDF = e => {
        e.preventDefault();
        this.ConfirmationModal.current.handleClose();
        // WAITING FOR IMPLEMENTATION
        // const report = new JsPDF('portrait','pt','a4');
        // report.html(document.querySelector('#report')).then(() => {
        //     report.save('report.pdf');
        // });
    }

    getRequestTypeLabel = (item) => {
        if (item.RequestTypeID === REQUEST_TYPES_ID.intlRoamingAccess) {
            return REQUEST_TYPE.InternationalAccess;
        }
        return item.RequestType;
    };

    render() {
        const { userLogo, userName, phoneNumberType, userPhoneNumber, setAsPrimary, activeCircuit,
            planInfo, vendorName, circuitStatus, simCount, simType, equipmentCount, equipmentModel, subscriptionIsPrimary, currencySymbol, circuitData, activeMenu, upgradeEligibilityDate } = this.props;

        const { requestTypes, isRequestTypesLoaded } = this.props.createRequest;
        let noAccess = parseInt(activeMenu) === parseInt(DashboardMenu.Personal) ?
            validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.PersonalDashboardRW])
            : validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MyDirectReportsDashboardRW]);
        const safePlanInfo = planInfo ?? [];
        
        let actionRequestItems;
        if (circuitData && isRequestTypesLoaded) {

            var actionRequestData = parseInt(circuitData?.subscriptionInfo?.CircuitCategoryModel?.CircuitCategoryId) === parseInt(CircuitCategories?.mobile) ?
                (requestTypes.Wireless ? requestTypes.Wireless.ActionsAndRequests : []) : (requestTypes.Wireline ? requestTypes.Wireline.ActionsAndRequests : []);

            if (requestTypes.Wireless && Object.keys(requestTypes.Wireless).length) {
                var actionsAndRequests = null;

                if (actionRequestData.length) {
                    actionsAndRequests = [
                        actionRequestData.map((requestType) => {
                            return (
                                <Dropdown.Item
                                    key={requestType.RequestTypeID}
                                    onClick={() =>
                                        this.openRequestModal(requestType.RequestTypeID, this.getRequestTypeLabel(requestType))
                                    }
                                >
                                    {this.getRequestTypeLabel(requestType)}
                                </Dropdown.Item>
                            );
                        }),
                    ];
                }

                actionRequestItems = actionsAndRequests;

            }

        } else {
            actionRequestItems = null;
        }

        return (
            <div>
                <ConfirmationModal
                    ref={this.ConfirmationModal}
                    title={<Translation translationKey="export_to_pdf" />}
                    messageBody={<Translation translationKey="do_you_like_this_to_export_to_pdf_file" />}
                    confirmAction={this.handleGeneratePDF}
                    closeLabel={<Translation translationKey="modal_close_cancel_button" />}
                    confirmLabel={<Translation translationKey="yes_button" />}
                />
                <div className="subscription-detail-container">
                    <div className="subscription-detail-info">
                        <div className="subscription-type-container">
                            <h1 className="subscription-type">{vendorName}</h1>
                            <h1 className="subscription-type">{simCount <= 1 ? "": "(" + simCount + ")" } <Translation translationKey="sim_type" />: {simType}</h1>
                            <h1 className="subscription-type">{phoneNumberType}</h1>
                        </div>
                    </div>
                  

                    <div className="subscription-plan-container">
                        <img
                            className="subscription-user-image"
                            src={userLogo}
                            alt="avatar"
                        />
                        <div className="subscription-user-container">
                            <div className="subscription-user-detail">
                           
                                <h1 className="subscription-user-detail">{userName}</h1>

                                <div className="three-dot-container" hidden={parseInt(circuitStatus) === parseInt(CircuitStatus.InService) || parseInt(circuitStatus) === parseInt(CircuitStatus.Pending) ? false : true } >
                                    <DropdownButton
                                        hidden={noAccess}
                                        as={ButtonGroup}
                                        title=""
                                        id="bg-vertical-dropdown-2"
                                        className="subscription-price-btn"
                                    >
                                        {actionRequestItems}
                                    </DropdownButton>
                                </div>
                            </div>
                            <div className="subscription-user-sub-detail">

                                <h2 className="subscription-user-phone">{userPhoneNumber}</h2>
                                {subscriptionIsPrimary ?
                                    <Icon
                                        customClassName="icon-check"
                                        name="check-circle-solid"
                                        labelValue={<Translation translationKey="primary_number" />}
                                        size="15px"
                                        hidden={subscriptionIsPrimary }
                                        containerClass="icon-container" /> :
                                    <a hidden={true} className="set-as-primary-number" onClick={() => setAsPrimary(activeCircuit)}>
                                        <Translation translationKey="set_as_primary_number" />
                                    </a>
                                }
                            </div>
                            <div className="subscription-user-sub-detail">
                                <h2 className={`subscription-user-phone ${activeCircuit.CircuitStatus === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended"}`}>
                                    {activeCircuit.CircuitStatus}
                                </h2>
                            </div>
                            <div className="subscription-user-sub-detail">
                                {equipmentCount > 0 ?
                                    <h2 className="subscription-user-phone">{equipmentModel}</h2>
                                    :
                                    <h2 className="subscription-user-phone">N/A</h2>
                                }
                            </div>
                            <div className="subscription-user-sub-detail">
                                <h2 className="subscription-user-phone"><Translation translationKey="upgrade_eligibility_date" />: {upgradeEligibilityDate !== "" ? <FormatDate date={convertToDate(upgradeEligibilityDate)} /> : "N/A" }</h2>
                            </div>
                        </div>
                        <div className="subscription-plan-item-container" id="report">
                            <div className="subscription-list-plan">
                                <div className="subscription-title-container">
                                    <h1 className="subscription-plan-title">
                                    {safePlanInfo.length > 0
                                        ? safePlanInfo[0].PlanName
                                        : <Translation translationKey="no_plan_available" />}
                                    </h1>
                                    <div className="details-info">
                                        <Icon
                                            customClassName="icon-info-circle icon-info-header"
                                            name="info-circle-solid"
                                            size="15px"
                                        />
                                        <div className="plan-details-list">
                                            <ul className="plan-details-list-item">
                                            {safePlanInfo.length > 0
                                                ? safePlanInfo.map((item, id) => (
                                                    <li key={id}>{item.ComponentDetails}</li>
                                                ))
                                                : <li><Translation translationKey="no_plan_available" /></li>}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="subscription-detail-list">
                                    <table className="table subscription-header-table">
                                        <tbody>
                                        {(planInfo ?? []).map((item, id) => (
                                            <tr key={id}>
                                            <td>{item.ComponentName}</td>
                                            <td>{currencySymbol} {item.ComponentCost}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="subscription-total-container">
                                <h1 className="subscription-total-amount">{currencySymbol}{` ${(planInfo != null ? planInfo?.reduce((a, v) => a = a + v.ComponentCost, 0) : 0)}`}</h1>
                                <h2 className="subscription-total-label">Total</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => {
        const { circuitUsage, createRequest } = state;
        return {
            ...circuitUsage
            , createRequest
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, circuitUsageActions, createRequestActions),
            dispatch
        )
)(SubscriptionOverviewInfo);